const pre = 'benefits/';
export default {
  // Action types with side-effects
  FETCH_PLAN_SUBSIDIES_REQUEST: `${pre}FETCH_PLAN_SUBSIDIES_REQUEST`,
  FETCH_PLAN_SUBSIDIES_SUCCESS: `${pre}FETCH_PLAN_SUBSIDIES_SUCCESS`,
  FETCH_PLAN_SUBSIDIES_FAILURE: `${pre}FETCH_PLAN_SUBSIDIES_FAILURE`
};